<template>
    <a href="javascript:"
       class="btn"
       :class="finalButtonClass"
       @click="handleClick">
      <slot></slot>
    </a>
</template>
<script>
export default {
  name: 'whaty-button',
  props: {
    buttonText: {
      type: String,
      require: false,
      default: ''
    },
    buttonClass: {
      type: [Array, String],
      require: false,
      default: ''
    },
    disabled: Boolean
  },
  data() {
    return {
    }
  },
  computed: {
    finalButtonClass: function () {
      let btnClass = []
      if (this.buttonClass) {
        if (typeof this.buttonClass === 'string') {
          btnClass.push(this.buttonClass)
        } else if (this.buttonClass instanceof Array) {
          btnClass.push(this.buttonClass)
        }
      }
      if (this.disabled) {
        btnClass.push('btn-disabled')
      }
      return btnClass
    }
  },
  methods: {
    handleClick() {
      if (this.disabled) {
        return
      }
      this.$emit('click')
    }
  }
}
</script>
<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/whaty-button.vue